import React from 'react'
import { useState } from 'react'
import ContentBox from "./ContentBox"
import {Link} from "react-router-dom"
import ServiceCardDetailAutogas from './ServiceCardDetailAutogas'
import ServiceCardDetailCilindro from "./ServiceCardDetailCilindro"


const Selector = (data, value, handler, title) => {
    if(data){
        if(data.length > 1){
            return(
                <div className="options-number-customer">
                    {title === "Autogas" && 
                        <span>N° de Patente</span>
                    }    
                    <select value={value && title === "Autogas" ? value.patent : value ? value.client_id : '' } onChange={(e) => handler(e.target.value)}>
                        {data.map((service, i) =>
                            {
                                return(
                                    <option key={i} value={title === "Autogas" ? service.patent : service.client_id}>
                                        {title === "Autogas" ? service.patent : "N° de Cliente " }
                                    </option>
                                )
                            })}
                    </select>
                </div>
            );
        }    
        return(
            <div className="box-border margin-top-40">
                {title === "Autogas" && <span>N° de Patente</span>} 
                {title === "Autogas" ? data[0].patent : "N° de Cliente "}
            </div>
        );
    }
}

const CustomSelector = ({selectorData, selectorValue, handleSelect,toogleCustomSelector})=> {
    const onCustomSelector = (clientCod)=> {
        handleSelect(clientCod);
        toogleCustomSelector();
    }

    return(
    <div 
        style={{
            position: 'absolute', 
            top: isMobileDevice() ? '-180px' : '',
            left: 0,
            overflowY: 'auto', 
            width: '100%', 
            height: 'fit-content',
            maxHeight: isMobileDevice() ? 200 : 150,
            paddingInline: 12, 
            background: 'white', 
            boxShadow: '0 0 8px rgba(0,0,0,0.2)'
        }}
    >
        {selectorData
        .filter(option=> option !== selectorValue)
        .map((option,i)=> {
            return(
                <p 
                    key={'ServiceCardOptionCustom'+i}
                    style={{
                        paddingBlock:12,
                        borderTop: i !== 0 ? '1px solid #e9e9e9':'',
                        textAlign: 'start'
                    }}
                    onClick={()=>onCustomSelector(option.client_id)}
                >
                    {option.client_address}
                    <br />
                    {option.client_city + ", " + option.client_region_cod}
                </p>
            );
        })}
    </div>
        
    )
}


export default function ServiceCard({title, icon, loading, selectorData, selectorValue, handleSelect, links, setLoading, isCustomSelector = false }) {
    const [showCustomOptions, setShowCustomOptions] = useState(false);
    
    const toogleCustomSelector= ()=> {
        if(!selectorData.length && !isCustomSelector) return;
        setShowCustomOptions(!showCustomOptions);
    }
    
    return (
        <ContentBox className="margin-top-40 margin-bottom-40 overflow-hidden" loading={loading}>
            <div className="servicios-servicio-box-leftside-2">
      			<img className="servicios-servicio-box-type-img" src={icon} alt="medidor" />
      			<div className="servicios-servicio-box-type">
      				<p>{title}</p>
  				</div>    
                          
				{!isCustomSelector && 
                    Selector(selectorData, selectorValue, handleSelect, title)
                }
			</div>

            <div className="servicios-servicio-box-links">
                {links && links.length > 0 && 
                    links.map((link, i) => {
                        if (link.available) {
                            return(
                                <div key={i} className="linkA-container">
                                    <Link to={link.url}>{link.link}</Link>
                                </div>
                            )
                        }
                    })
                }
            </div>

            <div className="servicios-servicio-box-details" style={{position:'relative'}}>
                {selectorValue && title === "Autogas" && 
                    <ServiceCardDetailAutogas selectorValue={selectorValue} setLoading={(x) => setLoading(x)}/>
                }

                {selectorValue && title === "Cilindro" &&
                    <>
                        <ServiceCardDetailCilindro 
                            selectorValue={selectorValue} 
                            isCustomSelector={!!selectorData.length && isCustomSelector} 
                            handleCustomSelector={toogleCustomSelector}/>

                        {selectorData.length && isCustomSelector && showCustomOptions && 
                            CustomSelector({selectorData, selectorValue, handleSelect, toogleCustomSelector})
                        }   
                    </> 
                }
            </div>
        </ContentBox>
    )
}


function isMobileDevice() {
    try {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
      return false;
    }
}